const DATUM = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });

export function formatDatum(iso: string | null | undefined): string {
  if (!iso) return '–';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return DATUM.format(d);
}

export function formatEuro(wert: number | null | undefined): string {
  if (wert === null || wert === undefined) return '–';
  return wert.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}

export const SERVIERT_ALS_LABEL: Record<string, string> = {
  TELLER: 'Teller',
  GLAS: 'Glas',
  BECHER: 'Becher',
  TO_GO: 'to go',
};

export const WIEDERKOMMEN_LABEL: Record<string, string> = {
  JA: 'ja',
  VIELLEICHT: 'vielleicht',
  NEIN: 'nein',
};
